module.exports = __webpack_public_path__ + "img/scenario-login.1b97a99.svg";